/// Helpers for the Configure step's axis-defaults / dirty-state logic.
///
/// `defaultsFor(expert, archetypeId)` returns the archetype's baseline
/// directly. Register overlay (PT/BR softens, DE/NL hardens, etc.) is
/// applied by the api at meeting-create, not on the picker — the SPA
/// shows the pre-overlay baseline. If a future iteration needs the
/// picker to mirror the post-overlay defaults, the overlay table moves
/// here.

import type {
  ArchetypeSummary,
  AxisValues,
  ExpertSummary,
} from "../api";

const FALLBACK_BASELINE: AxisValues = {
  assertiveness: "recommends",
  responsiveness: "balanced",
  evidence: "cited",
};

export function defaultsFor(
  expert: ExpertSummary | null,
  archetypeId: string | null,
): AxisValues {
  if (!expert || !archetypeId) return FALLBACK_BASELINE;
  const archetypes: ArchetypeSummary[] = expert.archetypes ?? [];
  const arch = archetypes.find((a) => a.id === archetypeId);
  return arch?.baseline ?? FALLBACK_BASELINE;
}

export function axisValuesEqual(a: AxisValues, b: AxisValues): boolean {
  return (
    a.assertiveness === b.assertiveness &&
    a.responsiveness === b.responsiveness &&
    a.evidence === b.evidence
  );
}
